import styled from 'styled-components'
import tw from 'twin.macro'

export const NavList = styled.ul`
  ${tw`relative flex mx-16 ml-2 row`}
`
export const NavMenu = styled.div`
  ${tw`px-48 mx-auto row bg-seaweed`};
`
